module.exports = __webpack_public_path__ + "img/print-logo.9a570ff4.jpg";